
import { get } from '@/utils/request'
export default {
  namespaced: true,
  state: {
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    // 获取任务记录列表
    async getAllWorkTaskListBySubject(context, params) {
      const res = await get('Study/newDesk/getAllWorkTaskListBySubjectByPage', params)
      return res
    },
    // 获取任务类型
    async getTaskTypeList(context, params) {
      const res = await get('Study/newDesk/getTaskTypeList', params)
      return res
    }

  }
}

